import { Container } from "aurelia-dependency-injection";
import { inject } from "aurelia-framework";
import { Router } from "aurelia-router";
import { AuthService } from "../../services/authService";
import { UserMessageService } from "../../services/userMessageService";
//import {SmtpSettingAPI} from '../../services/admin/smtpSettingAPI';
import { VerbiageSettingAPI } from "../../services/admin/verbiageSettingAPI";
import { AccountAPI } from "../../services/accountAPI";
import $ from "jquery";
import Quill from "quill";
@inject(AuthService, Router, UserMessageService, AccountAPI)
export class Storage {
  constructor(authService, router, userMessageService, accountAPI) {
    this.accountAPI = accountAPI;
    this.authService = authService;
    this.router = router;
    this.userMessageService = userMessageService;
    this.branded_video = "";
    this.simple_collection = "";
    this.account_id = "";
    this.whitelabel_id = "";
    this.saving = false;
    this.site_url = window.site_url;
    this.storageData = {};
    const account = this.authService.getAccount();
    this.biz_url = account.biz_url;
    this.bizUrl = this.biz_url;
    this.magnfiLink =
      this.site_url +
      "/biz/" +
      (account.biz_url ? account.biz_url : account.link_id);

    this.totalStorage = 0;
  }

  attached() {}
  activate(params) {
    this.load();
  }

  load() {
    this.accountAPI.getStorageUsed(
      this.authService.getUser().token,
      this.saveLoadSuccess.bind(this),
      this.saveLoadError.bind(this)
    );
  }

  formatBytes(bytes, decimals = 2) {
    if (bytes === 0 || bytes == null) return "0 KB";

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }
  getData() {
    //console.log('Editor ======>>>> ')
    //console.log(this.bodyEditor.container);
    let data = {
      account_id: this.userInfo.id,
      whitelabel_id: this.userInfo.whitelabel_id,
      parent_wl_id: this.userInfo.whitelabel_id || null,
      branded_video: this.branded_video_editor.container.firstChild.innerHTML,
      simple_collection:
        this.simple_collection_editor.container.firstChild.innerHTML,
      role: this.userInfo.role,
    };
    console.log("verbiage data ", data);
    return data;
  }

  saveLoadSuccess(data) {
    console.log("verbiage", data);
    this.storageData = data;
    console.log("sssas", this.storageData);
    this.totalStorage =
      parseInt(
        this.storageData.brandVideo.TOTAL != null
          ? this.storageData.brandVideo.TOTAL
          : 0
      ) +
      parseInt(
        this.storageData.videoEmail.TOTAL != null
          ? this.storageData.videoEmail.TOTAL
          : 0
      ) +
      parseInt(
        this.storageData.videoMessage.TOTAL != null
          ? this.storageData.videoMessage.TOTAL
          : 0
      ) +
      parseInt(
        this.storageData.caseStudy.TOTAL != null
          ? this.storageData.caseStudy.TOTAL
          : 0
      ) +
      parseInt(
        this.storageData.testimonialRequest.TOTAL != null
          ? this.storageData.testimonialRequest.TOTAL
          : 0
      ) +
      parseInt(
        this.storageData.testimonialLinkSubmission.TOTAL
          ? this.storageData.testimonialLinkSubmission.TOTAL
          : 0
      );
    console.log("sdfff", this.totalStorage);
    // this.branded_video_editor.container.firstChild.innerHTML = data.verbiage.branded_video_verbiage;
    // this.simple_collection_editor.container.firstChild.innerHTML = data.verbiage.simple_collection_verbiage;
  }

  saveLoadError(msg) {
    this.userMessageService.setUserError("user", msg);
    this.loading = false;
  }
}
